import { Injectable, inject } from '@angular/core';

import { UsersService } from '../services/users/users.service';

/**
 * Resolver to fetch all timezones
 */
@Injectable()
export class InstallersResolver {
  private readonly usersService = inject(UsersService);


  resolve() {
    return this.usersService.getInstallers();
  }
}
